function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.63 1.262h38.625c1.528 0 2.759 1.317 2.759 2.954v47.263c0 1.636-1.231 2.954-2.76 2.954H8.632c-1.529 0-2.76-1.318-2.76-2.954V4.216c0-1.637 1.231-2.954 2.76-2.954z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.399 40.858V21.06h35.088v19.798zM21.483 7.258c0-1.25.964-2.263 2.153-2.263 1.19 0 2.154 1.013 2.154 2.263s-.964 2.262-2.154 2.262c-1.189 0-2.153-1.013-2.153-2.262zM30.096 7.258c0-1.25.964-2.263 2.153-2.263s2.154 1.013 2.154 2.263-.964 2.262-2.154 2.262-2.153-1.013-2.153-2.262zM12.87 7.258c0-1.25.964-2.263 2.153-2.263s2.154 1.013 2.154 2.263-.964 2.262-2.154 2.262-2.153-1.013-2.153-2.262zM38.709 7.258c0-1.25.964-2.263 2.153-2.263s2.154 1.013 2.154 2.263-.964 2.262-2.154 2.262-2.153-1.013-2.153-2.262zM5.872 12.575h44.142M5.871 44.252h44.143M9.833 15.969h36.22a1.13 1.13 0 011.132 1.131 1.13 1.13 0 01-1.132 1.132H9.833A1.13 1.13 0 018.7 17.1a1.13 1.13 0 011.132-1.131z"
}));

var SvgOven = function SvgOven(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOven, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Oven.5e5d2028.svg";
export { ForwardRef as ReactComponent };